import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileAuditService } from '../file-audit.service';
import { NotificationsService } from 'angular2-notifications';

export interface LineStatus {
    id: number;
    name: string;
}

@Component({
    selector: 'automatic-debit-select-dialog',
    templateUrl: './changeStatusLineDialog.html',
    styles: [''],
})
export class ChangeStatusLineDialog implements OnInit {
    selected: any[];
    statusSelected: string = null;

    constructor(
        public dialogRef: MatDialogRef<ChangeStatusLineDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cdr: ChangeDetectorRef,
        private fileAuditService: FileAuditService,
        private notificationsService: NotificationsService,
    ) {
        this.selected = data.selected;
    }

    ngOnInit(): void {
        this.cdr.detectChanges();
    }

    closeModal() {
        this.dialogRef.close();
    }

    selectStatus(statusName: string) {
        this.statusSelected = statusName;
    }

    confirmStatus() {
        let statusToSend: LineStatus;
        if (this.statusSelected == 'Pendency') {
            statusToSend = { id: 9, name: 'Pendency' };
        } else if (this.statusSelected == 'StandBy') {
            statusToSend = { id: 0, name: 'StandBy' };
        } else if (this.statusSelected == 'Succeeded') {
            statusToSend = { id: 5, name: 'Succeeded' };
        } else {
            this.notificationsService.warn('Erro: Status não encontrado');
            return;
        }

        this.fileAuditService
            .ChangeStatusLine(
                this.selected.map((a) => a.id),
                statusToSend,
            )
            .subscribe((result) => {
                if (result.data == true) {
                    this.notificationsService.success('Alterado com sucesso');
                }
                if (result.data == false) {
                    this.notificationsService.warn(result.message);
                }
            });

        this.closeModal();
    }
}
